export default "__VITE_ASSET__C0RCS$W1__"